import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getTagsGQL = ({ first, offset, type, value, after }) => {
  const sql = `
      query(
          $offset: Int
          $first: Int
          $type: TagTypeEnum
          $value: String
      ){
            getTags(
                offset: $offset
                first: $first
                type: $type
                value: $value
            ){
                edges {
                   node {
                      id
                      value
                      type
                   }
                }
                totalCount
            }
      }
    `
  const params = { first, offset, type, value, after }
  return callAuthorizedGraphQLEndpoint(sql, params)
}

const deleteTagsGQL = ({ id }) => {
  const sql = `
      mutation deleteTag(
          $input: DeleteTagInput!
          ){
            deleteTag(input: $input) { 
                id
            }
      }
    `
  const params = { input: { id } }
  return callAuthorizedGraphQLEndpoint(sql, params)
}
export { getTagsGQL, deleteTagsGQL }
